import React, { useState } from 'react'
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';

import './style.css';
import RecentItem from './RecentItem';

function Contacts() {
   const blog = useSelector(state => state.blog.blog);
   const recent = useSelector(state => state.blog.recent);
   const [toggleState, setToggleState] = useState(1);

   const toggleTabs = (index) => {
      setToggleState(index);
   }

   return (
      <main className='contact_page'>
         <div className='contact_page--block _container'>
            <span className='contact_title'>Contact Us</span>
            <div className="contact_content--block">
               <ul className="out_contact">
                  <h2 className='list_title'>Our Contact</h2>
                  <li className="contact_list">
                     <h4>Address:</h4>
                     <span>Poland,Mazowieckie, Warszawa</span>
                  </li>
                  <li className="contact_list">
                     <h4>Phone numbers:</h4>
                     <span>(+48) 692 - 982 - 155</span>
                  </li>
                  <li className="contact_list">
                     <h4>Email:</h4>
                     <span>ViktorHarasymiv@studio.com</span>
                  </li>
               </ul>
               <ul className="reply_contact">
                  <h2 className='list_title'>Leave a reply</h2>
                  <li className="reply_list">
                     <label htmlFor='name'>Your Name</label>
                     <input id='name' type="name" />
                  </li>
                  <li className="reply_list">
                     <label htmlFor='email'>Your E-Mail</label>
                     <input id='email' type='email' pattern=".+@gmail.com" required />
                  </li>
                  <li className="reply_list">
                     <label htmlFor='subject'>Subject</label>
                     <input id='subject' type="text" />
                  </li>
                  <li className="reply_list reply_textarea">
                     <label htmlFor="textarea">Your Message (Optional)</label>
                     <textarea id='textarea' maxLength={500} required ></textarea>
                  </li>
                  <button className='btn_opinion'><span>Send Message</span></button>
               </ul>
               <div className="blog_archives--block ">
                  <div
                     className={toggleState === 1 ? "archives active" : "archives"}
                     onClick={() => toggleTabs(1)}>
                     <h3
                        className={toggleState === 1 ? "list_title blog--list_title active" : "list_title blog--list_title"}
                     >Archives</h3>
                     <ul className={toggleState === 1 ? "archives_list active" : "archives_list"}>
                        <Link><li className="blog_list"><span>March 2023</span>(0)</li></Link>
                        <Link><li className="blog_list"><span>February  2023</span>(0)</li></Link>
                        <Link><li className="blog_list"><span>January 2023</span>(0)</li></Link>
                     </ul>
                  </div>
                  <div
                     className={toggleState === 2 ? "categories active" : "categories"}
                     onClick={() => toggleTabs(2)}>
                     <h3
                        className={toggleState === 2 ? "list_title blog--list_title active" : "list_title blog--list_title"}
                     >Categories</h3>
                     <ul className={toggleState === 2 ? "categories_list active" : "categories_list"}>
                        <Link><li className="blog_list"><span>Interior Design 2023</span>({blog.length})</li></Link>
                        <Link><li className="blog_list"><span>Furniture 2023</span>(0)</li></Link>
                        <Link><li className="blog_list"><span>Flooring 2023</span>(0)</li></Link>
                     </ul>
                  </div>
                  <div
                     className={toggleState === 3 ? "recent active" : "recent"}
                     onClick={() => toggleTabs(3)}>
                     <h3
                        className={toggleState === 3 ? "list_title blog--list_title active" : "list_title blog--list_title"}
                     >Recent Posts</h3>
                     <ul className={toggleState === 3 ? "recent_list active" : "recent_list"}>
                        {recent.map(el => (
                           <li><RecentItem key={el.id} item={el} /></li>
                        ))}
                     </ul>
                  </div>

               </div>
            </div>
         </div>
      </ main>
   )
}

export default Contacts;

